var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 4c-4.42 0-8 3.58-8 8 0 4.41 3.58 8 8 8 4.41 0 8-3.59 8-8 0-4.42-3.59-8-8-8ZM2 12C2 6.47 6.47 2 12 2c5.52 0 10 4.47 10 10 0 5.52-4.48 10-10 10C6.47 22 2 17.52 2 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 8c-1.11 0-2 .89-2 2 0 1.1.89 2 2 2 1.1 0 2-.9 2-2 0-1.11-.9-2-2-2Zm-4 2c0-2.21 1.79-4 4-4 2.2 0 4 1.79 4 4 0 2.2-1.8 4-4 4 -2.21 0-4-1.8-4-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 16.5c-2.22 0-4.16 1.2-5.2 3l-1.74-1.01c1.38-2.39 3.96-4 6.92-4s5.54 1.61 6.92 3.99l-1.74 1c-1.04-1.8-2.98-3.01-5.2-3.01Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.0b7ccf26ebaef4441d824d283327929f.svg";
export { ForwardRef as ReactComponent };